import "../resource_collection/behavior.js";

// Each behavior must be registered with the name of the component template
class NewsBehavior extends Sparkle.PageBuilder.Components.ResourceCollectionAbstractBehavior {}
NewsBehavior.register("news");
